function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 5.5,
  y: 10.5,
  width: 13,
  height: 10,
  rx: 3.5,
  stroke: "#D61F26"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9V11H15V9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9V11H8V9Z",
  fill: "#D61F26"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0833 18V13C11.0833 13 12.9167 13 13.25 13C13.75 13 14.5 13.25 14.5 14.25C14.5 15.3333 13.8333 15.6667 13.3333 15.6667C12.75 15.6667 10 15.6667 10 15.6667",
  stroke: "#D61F26",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgBlockingDebt = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlockingDebt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blockingDebt.21eb6e25.svg";
export { ForwardRef as ReactComponent };